import { render, staticRenderFns } from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=template&id=baf04e90&scoped=true"
import script from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=script&lang=js"
export * from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=script&lang=js"
import style0 from "./CalendarAdminPlusScheduleClassDialog.vue?vue&type=style&index=0&id=baf04e90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf04e90",
  null
  
)

export default component.exports